export const conferenceTypesEnum = {
    'group': 'group', //Групповой
    'private': 'private', //Индивидуальный
    'introduction': 'introduction', //Индивидуальный «Вводное»
    'customizable': 'customizable', //Настраиваемый
}
